import React, { createContext, useEffect, useState } from 'react';

export const LoginContext = createContext({});

export function LoginContextProvider({ children }) {
  const [state, setState] = useState({ hotels: null });

  useEffect(() => {
    const elem = document.getElementById('dom-events-subscriber');
    elem.addEventListener('notifyDeviceUuid', function (e) {
      actions.saveDeviceUuid(e.detail);
    });

    updateState({ kioskDeviceUuid: actions.getDeviceUuid() });
  }, []);

  const actions = {
    setHotels: hotels => {
      updateState({ hotels });
      localStorage.setItem('kiosk-hotels', JSON.stringify(hotels));
    },
    clearHotels: () => {
      updateState({ hotels: null });
      localStorage.removeItem('kiosk-hotels');
    },
    getKioskHotels: () => {
      return state.hotels || JSON.parse(localStorage.getItem('kiosk-hotels')) || null;
    },
    saveCurrentHotel: hotelId => {
      localStorage.setItem('kiosk-hotelId', hotelId);

      try {
        window.ReactNativeWebView.postMessage(
          `{"action":"kioskHotelSelected","hotelId":${hotelId}}`
        );
      } catch (error) {
        console.error(error);
      }
    },
    getCurrentHotel: () => {
      return localStorage.getItem('kiosk-hotelId');
    },
    clearCurrentHotel: () => {
      localStorage.removeItem('kiosk-hotelId');
    },
    saveUserToken: token => {
      localStorage.setItem('login-token', token);
    },
    saveUserType: type => {
      localStorage.setItem('kiosk-user-type', type);
    },
    getUserType: () => {
      if (typeof window !== 'undefined') {
        return localStorage.getItem('kiosk-user-type') || 'checkin';
      } else return 'checkin';
    },
    saveDeviceUuid: uuid => {
      updateState({ kioskDeviceUuid: uuid });
      localStorage.setItem('kiosk-device-uuid', uuid);
    },
    getDeviceUuid: () => {
      return localStorage.getItem('kiosk-device-uuid') || null;
    },
    savePaperlessVersion: version => {
      localStorage.setItem('paperless-version', version);
    },
    getPaperlessVersion: () => {
      return localStorage.getItem('paperless-version') || null;
    },
  };

  function updateState(newState) {
    setState(previousState => {
      const finalState = { ...previousState, ...newState };
      return finalState;
    });
  }

  return <LoginContext.Provider value={{ state, actions }}>{children}</LoginContext.Provider>;
}
